import { applyMiddleware, combineReducers, compose, createStore, ReducersMapObject } from 'redux';
import { ThunkDispatch, withExtraArgument } from 'redux-thunk';

import { IApplicationState, TApplicationStateInitial, TReduxActions } from '../../types/redux';
import { IApplicationContext } from '../../types/applicationContext';
import {
  footerTypeReducer,
  platformReducer,
  showSiteTypeChangingReducer,
  showAdditionalSeoLinksReducer,
  sectionReducer,
  downloadAppBannerReducer,
  agreementLinkReducer,
} from '../../reducers';

interface IThunkExt {
  dispatch: ThunkDispatch<IApplicationState, IApplicationContext, TReduxActions>;
}

/* istanbul ignore next */
const composeEnhancers = (() => {
  if (process.env.NODE_ENV === 'development' && process.env.IS_BROWSER_BUILD) {
    const { __REDUX_DEVTOOLS_EXTENSION_COMPOSE__ } = window;

    if (__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) {
      return __REDUX_DEVTOOLS_EXTENSION_COMPOSE__({
        name: `frontend-footer# ${document.title}`,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
      } as any);
    }
  }

  return compose;
})();

/**
 * Хелпер для создания Redux стора
 * @param {IApplicationState} initialState - предзагруженное состояние
 * @param {IApplicationContext} context
 */
export function createReduxStore(initialState: TApplicationStateInitial, context: IApplicationContext) {
  const reducers = combineReducers<ReducersMapObject<IApplicationState, TReduxActions>>({
    agreementLink: agreementLinkReducer,
    footerType: footerTypeReducer,
    platform: platformReducer,
    section: sectionReducer,
    showSiteTypeChanging: showSiteTypeChangingReducer,
    showAdditionalSeoLinks: showAdditionalSeoLinksReducer,
    downloadAppBannerDisabled: downloadAppBannerReducer,
  });

  const storeEnhancers = composeEnhancers(applyMiddleware(withExtraArgument(context)));

  return createStore<IApplicationState, TReduxActions, IThunkExt, {}, TApplicationStateInitial>(
    reducers,
    initialState,
    storeEnhancers,
  );
}
